import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function FeaturedSection() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 6);

  return (
    <section id="featured" className="py-16 md:py-20 bg-background-50" aria-labelledby="featured-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 id="featured-heading" className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">千万读者都在追的爆款漫画</p>
          </div>
          <Link
            to="/category/rexue"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4] bg-background-100">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50">
                    {comic.rating}分
                  </span>
                </div>
                {comic.isNew && (
                  <div className="absolute top-2 right-2">
                    <span className="inline-block px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-background-50">
                      NEW
                    </span>
                  </div>
                )}
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
                  <p className="text-xs text-background-50/80">{comic.author}</p>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.views} 阅读</p>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/rexue"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部热门漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}